import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A5TimeSeriesEdit } from "./edit";
import { A5TimeSeriesNew } from "./new";
import { A5TimeSeriesTable } from "./table";

export default function A5TimeSeries() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Valorisation");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<A5TimeSeriesEdit />} />
      <Route index element={<A5TimeSeriesTable />} />
      <Route path="/new" element={<A5TimeSeriesNew />} />
    </Routes>
  );
}
